// import React, { useState } from 'react';
// import {
//     Box,
//     Card,
//     Typography,
//     TextField,
//     Button,
//     IconButton,
//     Collapse,
//     Stack,
//     Chip
// } from '@mui/material';
// import AddIcon from '@mui/icons-material/Add';
// import CloseIcon from '@mui/icons-material/Close';
// import NotesIcon from '@mui/icons-material/Notes';
// import GavelIcon from '@mui/icons-material/Gavel';
// import { useFormContext } from 'react-hook-form';
// import { useResponsive } from '../../../../../utils/useResponsive';
// import { NotesTermsSectionProps } from '../../../types';


// const NotesTermsSection: React.FC<NotesTermsSectionProps> = ({
//     // Labels with defaults
//     notesLabel = 'Notes',
//     termsLabel = 'Terms & Conditions',
//     addNoteButtonText = 'Add Note',
//     addTermsButtonText = 'Add Terms & Conditions',
//     notesPlaceholder = 'Add any additional notes or instructions...',
//     termsPlaceholder = 'Add terms and conditions...',
    
//     // Form field names with defaults
//     formFieldNames = {
//         notes: 'notes',
//         terms: 'terms'
//     },
    
//     // Values
//     notes: propNotes,
//     terms: propTerms,
    
//     // Callbacks
//     onNotesChange,
//     onTermsChange,
    
//     // Configuration with defaults
//     showNotes = true,
//     showTerms = true,
//     allowMultipleNotes = false,
//     allowMultipleTerms = false,
//     maxNotes = 5,
//     maxTerms = 5,
//     disabled = false,
//     compact = false,
    
//     // Validation with defaults
//     maxNotesLength = 1000,
//     maxTermsLength = 2000,
//     defaultExpanded = false
// }) => {
//     // State for expanded sections
//     const [notesExpanded, setNotesExpanded] = useState(false);
//     const [termsExpanded, setTermsExpanded] = useState(false);
    
//     // State for multiple notes/terms if enabled
//     const [notesList, setNotesList] = useState<string[]>(propNotes ? [propNotes] : []);
//     const [termsList, setTermsList] = useState<string[]>(propTerms ? [propTerms] : []);
    
//     // Responsive hook
//     const { isMobile, isMobileOrTablet } = useResponsive();
    
//     // Determine compact mode based on screen size if not explicitly set
//     const shouldBeCompact = compact || isMobileOrTablet;
    
//     // React Hook Form integration
//     const { register, setValue, watch } = useFormContext?.() || {};
    
//     // Get form values if using react-hook-form
//     const formNotes = formFieldNames.notes ? watch?.(formFieldNames.notes) : undefined;
//     const formTerms = formFieldNames.terms ? watch?.(formFieldNames.terms) : undefined;
    
//     // Use form values if available, otherwise use props
//     const displayNotes = formNotes !== undefined ? formNotes : propNotes;
//     const displayTerms = formTerms !== undefined ? formTerms : propTerms;

//     // Handle notes change
//     const handleNotesChange = (value: string, index?: number) => {
//         if (allowMultipleNotes) {
//             const updatedNotes = [...notesList];
//             if (index !== undefined) {
//                 updatedNotes[index] = value;
//                 setNotesList(updatedNotes);
//             }
//             // For multiple notes, store as array
//             if (formFieldNames.notes && setValue) {
//                 setValue(formFieldNames.notes, updatedNotes);
//             }
//         } else {
//             // For single note, store as string
//             if (formFieldNames.notes && setValue) {
//                 setValue(formFieldNames.notes, value);
//             }
//             if (onNotesChange) {
//                 onNotesChange(value);
//             }
//         }
//     };

//     // Handle terms change
//     const handleTermsChange = (value: string, index?: number) => {
//         if (allowMultipleTerms) {
//             const updatedTerms = [...termsList];
//             if (index !== undefined) {
//                 updatedTerms[index] = value;
//                 setTermsList(updatedTerms);
//             }
//             // For multiple terms, store as array
//             if (formFieldNames.terms && setValue) {
//                 setValue(formFieldNames.terms, updatedTerms);
//             }
//         } else {
//             // For single term, store as string
//             if (formFieldNames.terms && setValue) {
//                 setValue(formFieldNames.terms, value);
//             }
//             if (onTermsChange) {
//                 onTermsChange(value);
//             }
//         }
//     };

//     // Add new note (for multiple notes)
//     const handleAddNote = () => {
//         if (notesList.length < maxNotes) {
//             const newNotes = [...notesList, ''];
//             setNotesList(newNotes);
//             if (formFieldNames.notes && setValue) {
//                 setValue(formFieldNames.notes, newNotes);
//             }
//         }
//     };

//     // Add new term (for multiple terms)
//     const handleAddTerm = () => {
//         if (termsList.length < maxTerms) {
//             const newTerms = [...termsList, ''];
//             setTermsList(newTerms);
//             if (formFieldNames.terms && setValue) {
//                 setValue(formFieldNames.terms, newTerms);
//             }
//         }
//     };

//     // Remove note (for multiple notes)
//     const handleRemoveNote = (index: number) => {
//         const newNotes = notesList.filter((_, i) => i !== index);
//         setNotesList(newNotes);
//         if (formFieldNames.notes && setValue) {
//             setValue(formFieldNames.notes, newNotes);
//         }
//     };

//     // Remove term (for multiple terms)
//     const handleRemoveTerm = (index: number) => {
//         const newTerms = termsList.filter((_, i) => i !== index);
//         setTermsList(newTerms);
//         if (formFieldNames.terms && setValue) {
//             setValue(formFieldNames.terms, newTerms);
//         }
//     };

//     return (
//         <Card sx={{
//             p: shouldBeCompact ? 1.5 : 2,
//             borderRadius: 1,
//             width: '100%',
//             height:"100%"
//         }}>
//             {/* Notes Section */}
//             {showNotes && (
//                 <Box sx={{ mb: 3 }}>
//                     <Box sx={{ 
//                         display: 'flex', 
//                         justifyContent: 'space-between', 
//                         alignItems: 'center',
//                         mb: 1
//                     }}>
//                         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                             <NotesIcon 
//                                 fontSize={shouldBeCompact ? "small" : "medium"} 
//                                 color="primary" 
//                             />
//                             <Typography
//                                 variant={shouldBeCompact ? "body2" : "body1"}
//                                 fontWeight="medium"
//                             >
//                                 {notesLabel}
//                                 <Typography
//                                     component="span"
//                                     variant="caption"
//                                     color="text.secondary"
//                                     sx={{ ml: 0.5 }}
//                                 >
//                                     (Optional)
//                                 </Typography>
//                             </Typography>
//                         </Box>
                        
//                         {!notesExpanded && (
//                             <Button
//                                 size={shouldBeCompact ? "small" : "medium"}
//                                 startIcon={<AddIcon />}
//                                 onClick={() => setNotesExpanded(true)}
//                                 disabled={disabled}
//                                 sx={{ 
//                                     textTransform: 'none',
//                                     fontSize: isMobile ? '0.75rem' : '0.875rem'
//                                 }}
//                             >
//                                 {addNoteButtonText}
//                             </Button>
//                         )}
//                     </Box>
                    
//                     <Collapse in={notesExpanded}>
//                         <Box sx={{ mb: 2 }}>
//                             {allowMultipleNotes ? (
//                                 <Stack spacing={2}>
//                                     {notesList.map((note, index) => (
//                                         <Box key={index} sx={{ position: 'relative' }}>
//                                             <TextField
//                                                 fullWidth
//                                                 multiline
//                                                 rows={3}
//                                                 size={shouldBeCompact ? "small" : "medium"}
//                                                 disabled={disabled}
//                                                 value={note}
//                                                 onChange={(e) => handleNotesChange(e.target.value, index)}
//                                                 placeholder={notesPlaceholder}
//                                                 InputProps={{
//                                                     sx: { 
//                                                         fontSize: isMobile ? '0.875rem' : 'inherit',
//                                                         pr: 6
//                                                     }
//                                                 }}
//                                                 {...(formFieldNames.notes && register?.(formFieldNames.notes))}
//                                             />
//                                             {notesList.length > 1 && (
//                                                 <IconButton
//                                                     size="small"
//                                                     onClick={() => handleRemoveNote(index)}
//                                                     sx={{
//                                                         position: 'absolute',
//                                                         top: 8,
//                                                         right: 8,
//                                                         bgcolor: 'background.paper'
//                                                     }}
//                                                 >
//                                                     <CloseIcon fontSize="small" />
//                                                 </IconButton>
//                                             )}
//                                             <Typography
//                                                 variant="caption"
//                                                 color="text.secondary"
//                                                 sx={{ mt: 0.5, display: 'block' }}
//                                             >
//                                                 {note.length}/{maxNotesLength} characters
//                                             </Typography>
//                                         </Box>
//                                     ))}
                                    
//                                     {notesList.length < maxNotes && (
//                                         <Button
//                                             size={shouldBeCompact ? "small" : "medium"}
//                                             startIcon={<AddIcon />}
//                                             onClick={handleAddNote}
//                                             disabled={disabled}
//                                             variant="outlined"
//                                             sx={{ 
//                                                 textTransform: 'none',
//                                                 alignSelf: 'flex-start'
//                                             }}
//                                         >
//                                             Add Another Note
//                                         </Button>
//                                     )}
//                                 </Stack>
//                             ) : (
//                                 <>
//                                     <TextField
//                                         fullWidth
//                                         multiline
//                                         rows={4}
//                                         size={shouldBeCompact ? "small" : "medium"}
//                                         disabled={disabled}
//                                         value={displayNotes || ''}
//                                         onChange={(e) => handleNotesChange(e.target.value)}
//                                         placeholder={notesPlaceholder}
//                                         InputProps={{
//                                             sx: { 
//                                                 fontSize: isMobile ? '0.875rem' : 'inherit'
//                                             }
//                                         }}
//                                         {...(formFieldNames.notes && register?.(formFieldNames.notes, {
//                                             maxLength: {
//                                                 value: maxNotesLength,
//                                                 message: `Notes cannot exceed ${maxNotesLength} characters`
//                                             }
//                                         }))}
//                                     />
//                                     <Box sx={{ 
//                                         display: 'flex', 
//                                         justifyContent: 'space-between',
//                                         alignItems: 'center',
//                                         mt: 1
//                                     }}>
//                                         <Typography
//                                             variant="caption"
//                                             color="text.secondary"
//                                         >
//                                             {displayNotes?.length || 0}/{maxNotesLength} characters
//                                         </Typography>
//                                         <IconButton
//                                             size="small"
//                                             onClick={() => setNotesExpanded(false)}
//                                             disabled={disabled}
//                                         >
//                                             <CloseIcon fontSize="small" />
//                                         </IconButton>
//                                     </Box>
//                                 </>
//                             )}
//                         </Box>
//                     </Collapse>
                    
//                     {/* Show chips for multiple notes when collapsed */}
//                     {!notesExpanded && allowMultipleNotes && notesList.filter(n => n.trim()).length > 0 && (
//                         <Box sx={{ mt: 1 }}>
//                             <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: 'block' }}>
//                                 Added notes:
//                             </Typography>
//                             <Stack direction="row" spacing={0.5} flexWrap="wrap" gap={0.5}>
//                                 {notesList.filter(n => n.trim()).map((note, index) => (
//                                     <Chip
//                                         key={index}
//                                         label={note.substring(0, 20) + (note.length > 20 ? '...' : '')}
//                                         size="small"
//                                         color="primary"
//                                         variant="outlined"
//                                         onDelete={() => handleRemoveNote(index)}
//                                     />
//                                 ))}
//                             </Stack>
//                         </Box>
//                     )}
//                 </Box>
//             )}
            
//             {/* Terms & Conditions Section */}
//             {showTerms && (
//                 <Box>
//                     <Box sx={{ 
//                         display: 'flex', 
//                         justifyContent: 'space-between', 
//                         alignItems: 'center',
//                         mb: 1
//                     }}>
//                         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                             <GavelIcon 
//                                 fontSize={shouldBeCompact ? "small" : "medium"} 
//                                 color="primary" 
//                             />
//                             <Typography
//                                 variant={shouldBeCompact ? "body2" : "body1"}
//                                 fontWeight="medium"
//                             >
//                                 {termsLabel}
//                                 <Typography
//                                     component="span"
//                                     variant="caption"
//                                     color="text.secondary"
//                                     sx={{ ml: 0.5 }}
//                                 >
//                                     (Optional)
//                                 </Typography>
//                             </Typography>
//                         </Box>
                        
//                         {!termsExpanded && (
//                             <Button
//                                 size={shouldBeCompact ? "small" : "medium"}
//                                 startIcon={<AddIcon />}
//                                 onClick={() => setTermsExpanded(true)}
//                                 disabled={disabled}
//                                 sx={{ 
//                                     textTransform: 'none',
//                                     fontSize: isMobile ? '0.75rem' : '0.875rem'
//                                 }}
//                             >
//                                 {addTermsButtonText}
//                             </Button>
//                         )}
//                     </Box>
                    
//                     <Collapse in={termsExpanded}>
//                         <Box>
//                             {allowMultipleTerms ? (
//                                 <Stack spacing={2}>
//                                     {termsList.map((term, index) => (
//                                         <Box key={index} sx={{ position: 'relative' }}>
//                                             <TextField
//                                                 fullWidth
//                                                 multiline
//                                                 rows={4}
//                                                 size={shouldBeCompact ? "small" : "medium"}
//                                                 disabled={disabled}
//                                                 value={term}
//                                                 onChange={(e) => handleTermsChange(e.target.value, index)}
//                                                 placeholder={termsPlaceholder}
//                                                 InputProps={{
//                                                     sx: { 
//                                                         fontSize: isMobile ? '0.875rem' : 'inherit',
//                                                         pr: 6
//                                                     }
//                                                 }}
//                                                 {...(formFieldNames.terms && register?.(formFieldNames.terms))}
//                                             />
//                                             {termsList.length > 1 && (
//                                                 <IconButton
//                                                     size="small"
//                                                     onClick={() => handleRemoveTerm(index)}
//                                                     sx={{
//                                                         position: 'absolute',
//                                                         top: 8,
//                                                         right: 8,
//                                                         bgcolor: 'background.paper'
//                                                     }}
//                                                 >
//                                                     <CloseIcon fontSize="small" />
//                                                 </IconButton>
//                                             )}
//                                             <Typography
//                                                 variant="caption"
//                                                 color="text.secondary"
//                                                 sx={{ mt: 0.5, display: 'block' }}
//                                             >
//                                                 {term.length}/{maxTermsLength} characters
//                                             </Typography>
//                                         </Box>
//                                     ))}
                                    
//                                     {termsList.length < maxTerms && (
//                                         <Button
//                                             size={shouldBeCompact ? "small" : "medium"}
//                                             startIcon={<AddIcon />}
//                                             onClick={handleAddTerm}
//                                             disabled={disabled}
//                                             variant="outlined"
//                                             sx={{ 
//                                                 textTransform: 'none',
//                                                 alignSelf: 'flex-start'
//                                             }}
//                                         >
//                                             Add Another Term
//                                         </Button>
//                                     )}
//                                 </Stack>
//                             ) : (
//                                 <>
//                                     <TextField
//                                         fullWidth
//                                         multiline
//                                         rows={5}
//                                         size={shouldBeCompact ? "small" : "medium"}
//                                         disabled={disabled}
//                                         value={displayTerms || ''}
//                                         onChange={(e) => handleTermsChange(e.target.value)}
//                                         placeholder={termsPlaceholder}
//                                         InputProps={{
//                                             sx: { 
//                                                 fontSize: isMobile ? '0.875rem' : 'inherit'
//                                             }
//                                         }}
//                                         {...(formFieldNames.terms && register?.(formFieldNames.terms, {
//                                             maxLength: {
//                                                 value: maxTermsLength,
//                                                 message: `Terms cannot exceed ${maxTermsLength} characters`
//                                             }
//                                         }))}
//                                     />
//                                     <Box sx={{ 
//                                         display: 'flex', 
//                                         justifyContent: 'space-between',
//                                         alignItems: 'center',
//                                         mt: 1
//                                     }}>
//                                         <Typography
//                                             variant="caption"
//                                             color="text.secondary"
//                                         >
//                                             {displayTerms?.length || 0}/{maxTermsLength} characters
//                                         </Typography>
//                                         <IconButton
//                                             size="small"
//                                             onClick={() => setTermsExpanded(false)}
//                                             disabled={disabled}
//                                         >
//                                             <CloseIcon fontSize="small" />
//                                         </IconButton>
//                                     </Box>
//                                 </>
//                             )}
//                         </Box>
//                     </Collapse>
                    
//                     {/* Show chips for multiple terms when collapsed */}
//                     {!termsExpanded && allowMultipleTerms && termsList.filter(t => t.trim()).length > 0 && (
//                         <Box sx={{ mt: 1 }}>
//                             <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: 'block' }}>
//                                 Added terms:
//                             </Typography>
//                             <Stack direction="row" spacing={0.5} flexWrap="wrap" gap={0.5}>
//                                 {termsList.filter(t => t.trim()).map((term, index) => (
//                                     <Chip
//                                         key={index}
//                                         label={term.substring(0, 20) + (term.length > 20 ? '...' : '')}
//                                         size="small"
//                                         color="secondary"
//                                         variant="outlined"
//                                         onDelete={() => handleRemoveTerm(index)}
//                                     />
//                                 ))}
//                             </Stack>
//                         </Box>
//                     )}
//                 </Box>
//             )}
//         </Card>
//     );
// };

// export default NotesTermsSection;

import React, { useState } from 'react';
import {
    Box,
    Card,
    Typography,
    TextField,
    Button,
    IconButton,
    Collapse,
    Stack,
    Chip
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import NotesIcon from '@mui/icons-material/Notes';
import GavelIcon from '@mui/icons-material/Gavel';
import { useFormContext } from 'react-hook-form';
import { useResponsive } from '../../../../../utils/useResponsive';
import { NotesTermsSectionProps } from '../../../types';


const NotesTermsSection: React.FC<NotesTermsSectionProps> = ({
    // Labels with defaults
    notesLabel = 'Notes',
    termsLabel = 'Terms & Conditions',
    addNoteButtonText = 'Add Note',
    addTermsButtonText = 'Add Terms & Conditions',
    notesPlaceholder = 'Add any additional notes or instructions...',
    termsPlaceholder = 'Add terms and conditions...',
    
    // Form field names with defaults
    formFieldNames = {
        notes: 'notes',
        terms: 'terms'
    },
    
    // Values
    notes: propNotes,
    terms: propTerms,
    
    // Callbacks
    onNotesChange,
    onTermsChange,
    
    // Configuration with defaults
    showNotes = true,
    showTerms = true,
    allowMultipleNotes = false,
    allowMultipleTerms = false,
    maxNotes = 5,
    maxTerms = 5,
    disabled = false,
    compact = false,
    
    // Validation with defaults
    maxNotesLength = 1000,
    maxTermsLength = 2000,
    defaultExpanded = false
}) => {
    // State for expanded sections - USE defaultExpanded PROP HERE
    const [notesExpanded, setNotesExpanded] = useState(defaultExpanded);
    const [termsExpanded, setTermsExpanded] = useState(defaultExpanded);
    
    // State for multiple notes/terms if enabled
    const [notesList, setNotesList] = useState<string[]>(propNotes ? [propNotes] : []);
    const [termsList, setTermsList] = useState<string[]>(propTerms ? [propTerms] : []);
    
    // Responsive hook
    const { isMobile, isMobileOrTablet } = useResponsive();
    
    // Determine compact mode based on screen size if not explicitly set
    const shouldBeCompact = compact || isMobileOrTablet;
    
    // React Hook Form integration
    const { register, setValue, watch } = useFormContext?.() || {};
    
    // Get form values if using react-hook-form
    const formNotes = formFieldNames.notes ? watch?.(formFieldNames.notes) : undefined;
    const formTerms = formFieldNames.terms ? watch?.(formFieldNames.terms) : undefined;
    
    // Use form values if available, otherwise use props
    const displayNotes = formNotes !== undefined ? formNotes : propNotes;
    const displayTerms = formTerms !== undefined ? formTerms : propTerms;

    // Handle notes change
    const handleNotesChange = (value: string, index?: number) => {
        if (allowMultipleNotes) {
            const updatedNotes = [...notesList];
            if (index !== undefined) {
                updatedNotes[index] = value;
                setNotesList(updatedNotes);
            }
            // For multiple notes, store as array
            if (formFieldNames.notes && setValue) {
                setValue(formFieldNames.notes, updatedNotes);
            }
        } else {
            // For single note, store as string
            if (formFieldNames.notes && setValue) {
                setValue(formFieldNames.notes, value);
            }
            if (onNotesChange) {
                onNotesChange(value);
            }
        }
    };

    // Handle terms change
    const handleTermsChange = (value: string, index?: number) => {
        if (allowMultipleTerms) {
            const updatedTerms = [...termsList];
            if (index !== undefined) {
                updatedTerms[index] = value;
                setTermsList(updatedTerms);
            }
            // For multiple terms, store as array
            if (formFieldNames.terms && setValue) {
                setValue(formFieldNames.terms, updatedTerms);
            }
        } else {
            // For single term, store as string
            if (formFieldNames.terms && setValue) {
                setValue(formFieldNames.terms, value);
            }
            if (onTermsChange) {
                onTermsChange(value);
            }
        }
    };

    // Add new note (for multiple notes)
    const handleAddNote = () => {
        if (notesList.length < maxNotes) {
            const newNotes = [...notesList, ''];
            setNotesList(newNotes);
            if (formFieldNames.notes && setValue) {
                setValue(formFieldNames.notes, newNotes);
            }
        }
    };

    // Add new term (for multiple terms)
    const handleAddTerm = () => {
        if (termsList.length < maxTerms) {
            const newTerms = [...termsList, ''];
            setTermsList(newTerms);
            if (formFieldNames.terms && setValue) {
                setValue(formFieldNames.terms, newTerms);
            }
        }
    };

    // Remove note (for multiple notes)
    const handleRemoveNote = (index: number) => {
        const newNotes = notesList.filter((_, i) => i !== index);
        setNotesList(newNotes);
        if (formFieldNames.notes && setValue) {
            setValue(formFieldNames.notes, newNotes);
        }
    };

    // Remove term (for multiple terms)
    const handleRemoveTerm = (index: number) => {
        const newTerms = termsList.filter((_, i) => i !== index);
        setTermsList(newTerms);
        if (formFieldNames.terms && setValue) {
            setValue(formFieldNames.terms, newTerms);
        }
    };

    return (
        <Card sx={{
            p: shouldBeCompact ? 1.5 : 2,
            borderRadius: 1,
            width: '100%',
            height:"100%"
        }}>
            {/* Notes Section */}
            {showNotes && (
                <Box sx={{ mb: 3 }}>
                    <Box sx={{ 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        alignItems: 'center',
                        mb: 1
                    }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <NotesIcon 
                                fontSize={shouldBeCompact ? "small" : "medium"} 
                                color="primary" 
                            />
                            <Typography
                                variant={shouldBeCompact ? "body2" : "body1"}
                                fontWeight="medium"
                            >
                                {notesLabel}
                                <Typography
                                    component="span"
                                    variant="caption"
                                    color="text.secondary"
                                    sx={{ ml: 0.5 }}
                                >
                                    (Optional)
                                </Typography>
                            </Typography>
                        </Box>
                        
                        {/* This button only shows when notes are collapsed */}
                        {!notesExpanded && (
                            <Button
                                size={shouldBeCompact ? "small" : "medium"}
                                startIcon={<AddIcon />}
                                onClick={() => setNotesExpanded(true)}
                                disabled={disabled}
                                sx={{ 
                                    textTransform: 'none',
                                    fontSize: isMobile ? '0.75rem' : '0.875rem'
                                }}
                            >
                                {addNoteButtonText}
                            </Button>
                        )}
                    </Box>
                    
                    {/* Collapse component - expands when notesExpanded is true */}
                    <Collapse in={notesExpanded}>
                        <Box sx={{ mb: 2 }}>
                            {allowMultipleNotes ? (
                                <Stack spacing={2}>
                                    {notesList.map((note, index) => (
                                        <Box key={index} sx={{ position: 'relative' }}>
                                            <TextField
                                                fullWidth
                                                multiline
                                                rows={3}
                                                size={shouldBeCompact ? "small" : "medium"}
                                                disabled={disabled}
                                                value={note}
                                                onChange={(e) => handleNotesChange(e.target.value, index)}
                                                placeholder={notesPlaceholder}
                                                InputProps={{
                                                    sx: { 
                                                        fontSize: isMobile ? '0.875rem' : 'inherit',
                                                        pr: 6
                                                    }
                                                }}
                                                {...(formFieldNames.notes && register?.(formFieldNames.notes))}
                                            />
                                            {notesList.length > 1 && (
                                                <IconButton
                                                    size="small"
                                                    onClick={() => handleRemoveNote(index)}
                                                    sx={{
                                                        position: 'absolute',
                                                        top: 8,
                                                        right: 8,
                                                        bgcolor: 'background.paper'
                                                    }}
                                                >
                                                    <CloseIcon fontSize="small" />
                                                </IconButton>
                                            )}
                                            <Typography
                                                variant="caption"
                                                color="text.secondary"
                                                sx={{ mt: 0.5, display: 'block' }}
                                            >
                                                {note.length}/{maxNotesLength} characters
                                            </Typography>
                                        </Box>
                                    ))}
                                    
                                    {notesList.length < maxNotes && (
                                        <Button
                                            size={shouldBeCompact ? "small" : "medium"}
                                            startIcon={<AddIcon />}
                                            onClick={handleAddNote}
                                            disabled={disabled}
                                            variant="outlined"
                                            sx={{ 
                                                textTransform: 'none',
                                                alignSelf: 'flex-start'
                                            }}
                                        >
                                            Add Another Note
                                        </Button>
                                    )}
                                </Stack>
                            ) : (
                                <>
                                    <TextField
                                        fullWidth
                                        multiline
                                        rows={4}
                                        size={shouldBeCompact ? "small" : "medium"}
                                        disabled={disabled}
                                        value={displayNotes || ''}
                                        onChange={(e) => handleNotesChange(e.target.value)}
                                        placeholder={notesPlaceholder}
                                        InputProps={{
                                            sx: { 
                                                fontSize: isMobile ? '0.875rem' : 'inherit'
                                            }
                                        }}
                                        {...(formFieldNames.notes && register?.(formFieldNames.notes, {
                                            maxLength: {
                                                value: maxNotesLength,
                                                message: `Notes cannot exceed ${maxNotesLength} characters`
                                            }
                                        }))}
                                    />
                                    <Box sx={{ 
                                        display: 'flex', 
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        mt: 1
                                    }}>
                                        <Typography
                                            variant="caption"
                                            color="text.secondary"
                                        >
                                            {displayNotes?.length || 0}/{maxNotesLength} characters
                                        </Typography>
                                        <IconButton
                                            size="small"
                                            onClick={() => setNotesExpanded(false)}
                                            disabled={disabled}
                                        >
                                            <CloseIcon fontSize="small" />
                                        </IconButton>
                                    </Box>
                                </>
                            )}
                        </Box>
                    </Collapse>
                    
                    {/* Show chips for multiple notes when collapsed */}
                    {!notesExpanded && allowMultipleNotes && notesList.filter(n => n.trim()).length > 0 && (
                        <Box sx={{ mt: 1 }}>
                            <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: 'block' }}>
                                Added notes:
                            </Typography>
                            <Stack direction="row" spacing={0.5} flexWrap="wrap" gap={0.5}>
                                {notesList.filter(n => n.trim()).map((note, index) => (
                                    <Chip
                                        key={index}
                                        label={note.substring(0, 20) + (note.length > 20 ? '...' : '')}
                                        size="small"
                                        color="primary"
                                        variant="outlined"
                                        onDelete={() => handleRemoveNote(index)}
                                    />
                                ))}
                            </Stack>
                        </Box>
                    )}
                </Box>
            )}
            
            {/* Terms & Conditions Section */}
            {showTerms && (
                <Box>
                    <Box sx={{ 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        alignItems: 'center',
                        mb: 1
                    }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <GavelIcon 
                                fontSize={shouldBeCompact ? "small" : "medium"} 
                                color="primary" 
                            />
                            <Typography
                                variant={shouldBeCompact ? "body2" : "body1"}
                                fontWeight="medium"
                            >
                                {termsLabel}
                                <Typography
                                    component="span"
                                    variant="caption"
                                    color="text.secondary"
                                    sx={{ ml: 0.5 }}
                                >
                                    (Optional)
                                </Typography>
                            </Typography>
                        </Box>
                        
                        {/* This button only shows when terms are collapsed */}
                        {!termsExpanded && (
                            <Button
                                size={shouldBeCompact ? "small" : "medium"}
                                startIcon={<AddIcon />}
                                onClick={() => setTermsExpanded(true)}
                                disabled={disabled}
                                sx={{ 
                                    textTransform: 'none',
                                    fontSize: isMobile ? '0.75rem' : '0.875rem'
                                }}
                            >
                                {addTermsButtonText}
                            </Button>
                        )}
                    </Box>
                    
                    {/* Collapse component - expands when termsExpanded is true */}
                    <Collapse in={termsExpanded}>
                        <Box>
                            {allowMultipleTerms ? (
                                <Stack spacing={2}>
                                    {termsList.map((term, index) => (
                                        <Box key={index} sx={{ position: 'relative' }}>
                                            <TextField
                                                fullWidth
                                                multiline
                                                rows={4}
                                                size={shouldBeCompact ? "small" : "medium"}
                                                disabled={disabled}
                                                value={term}
                                                onChange={(e) => handleTermsChange(e.target.value, index)}
                                                placeholder={termsPlaceholder}
                                                InputProps={{
                                                    sx: { 
                                                        fontSize: isMobile ? '0.875rem' : 'inherit',
                                                        pr: 6
                                                    }
                                                }}
                                                {...(formFieldNames.terms && register?.(formFieldNames.terms))}
                                            />
                                            {termsList.length > 1 && (
                                                <IconButton
                                                    size="small"
                                                    onClick={() => handleRemoveTerm(index)}
                                                    sx={{
                                                        position: 'absolute',
                                                        top: 8,
                                                        right: 8,
                                                        bgcolor: 'background.paper'
                                                    }}
                                                >
                                                    <CloseIcon fontSize="small" />
                                                </IconButton>
                                            )}
                                            <Typography
                                                variant="caption"
                                                color="text.secondary"
                                                sx={{ mt: 0.5, display: 'block' }}
                                            >
                                                {term.length}/{maxTermsLength} characters
                                            </Typography>
                                        </Box>
                                    ))}
                                    
                                    {termsList.length < maxTerms && (
                                        <Button
                                            size={shouldBeCompact ? "small" : "medium"}
                                            startIcon={<AddIcon />}
                                            onClick={handleAddTerm}
                                            disabled={disabled}
                                            variant="outlined"
                                            sx={{ 
                                                textTransform: 'none',
                                                alignSelf: 'flex-start'
                                            }}
                                        >
                                            Add Another Term
                                        </Button>
                                    )}
                                </Stack>
                            ) : (
                                <>
                                    <TextField
                                        fullWidth
                                        multiline
                                        rows={5}
                                        size={shouldBeCompact ? "small" : "medium"}
                                        disabled={disabled}
                                        value={displayTerms || ''}
                                        onChange={(e) => handleTermsChange(e.target.value)}
                                        placeholder={termsPlaceholder}
                                        InputProps={{
                                            sx: { 
                                                fontSize: isMobile ? '0.875rem' : 'inherit'
                                            }
                                        }}
                                        {...(formFieldNames.terms && register?.(formFieldNames.terms, {
                                            maxLength: {
                                                value: maxTermsLength,
                                                message: `Terms cannot exceed ${maxTermsLength} characters`
                                            }
                                        }))}
                                    />
                                    <Box sx={{ 
                                        display: 'flex', 
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        mt: 1
                                    }}>
                                        <Typography
                                            variant="caption"
                                            color="text.secondary"
                                        >
                                            {displayTerms?.length || 0}/{maxTermsLength} characters
                                        </Typography>
                                        <IconButton
                                            size="small"
                                            onClick={() => setTermsExpanded(false)}
                                            disabled={disabled}
                                        >
                                            <CloseIcon fontSize="small" />
                                        </IconButton>
                                    </Box>
                                </>
                            )}
                        </Box>
                    </Collapse>
                    
                    {/* Show chips for multiple terms when collapsed */}
                    {!termsExpanded && allowMultipleTerms && termsList.filter(t => t.trim()).length > 0 && (
                        <Box sx={{ mt: 1 }}>
                            <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: 'block' }}>
                                Added terms:
                            </Typography>
                            <Stack direction="row" spacing={0.5} flexWrap="wrap" gap={0.5}>
                                {termsList.filter(t => t.trim()).map((term, index) => (
                                    <Chip
                                        key={index}
                                        label={term.substring(0, 20) + (term.length > 20 ? '...' : '')}
                                        size="small"
                                        color="secondary"
                                        variant="outlined"
                                        onDelete={() => handleRemoveTerm(index)}
                                    />
                                ))}
                            </Stack>
                        </Box>
                    )}
                </Box>
            )}
        </Card>
    );
};

export default NotesTermsSection;